<template>
  <div>
    <!--    <h3>-->
    <!--      تست شما به پایان رسید.-->
    <!--    </h3>-->
    <template>
      <div class=" mt-10  onboardingType" :class="{'text-right':$vuetify.rtl,'text-left':!$vuetify.rtl}">
        {{ $t('matchMaking.lastMessage[0]') }}
        {{ getPercentage(firstQuestionMatchMaking) }}%
        {{ $t('matchMaking.lastMessage[1]') }}
        <div class="my-5" :class="{'text-right':$vuetify.rtl,'text-left':!$vuetify.rtl}">
          <p v-for="(item , i) in primaryResult[firstQuestionMatchMaking]" :key="i">
            {{ item }}
          </p>
        </div>
        {{ $t('matchMaking.lastMessage[2]') }}
        <br>
      </div>
    </template>
    <br>
    <v-btn class="confirmBtn mt-3" id="firstStepBtn" color="#4576d8" elevation="0" @click="changeStep">
      <template>
        {{ $t('matchMaking.buttons.firstStep') }}

      </template>
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      primaryResult: {
        1: [
          this.$t('matchMaking.primaryResult.1[0]'),
          this.$t('matchMaking.primaryResult.1[1]'),
          this.$t('matchMaking.primaryResult.1[2]'),
          this.$t('matchMaking.primaryResult.1[3]'),
        ],
        2: [
          this.$t('matchMaking.primaryResult.2[0]'),
          this.$t('matchMaking.primaryResult.2[1]'),
          this.$t('matchMaking.primaryResult.2[2]'),
        ],
        3: [
          this.$t('matchMaking.primaryResult.3[0]'),
          this.$t('matchMaking.primaryResult.3[1]'),
          this.$t('matchMaking.primaryResult.3[2]'),
          this.$t('matchMaking.primaryResult.3[3]'),
        ],
        4: [
          this.$t('matchMaking.primaryResult.4[0]'),
          this.$t('matchMaking.primaryResult.4[1]'),
          this.$t('matchMaking.primaryResult.4[2]'),
        ],
        5: [
          this.$t('matchMaking.primaryResult.5[0]'),
          this.$t('matchMaking.primaryResult.5[1]'),
          this.$t('matchMaking.primaryResult.5[2]'),
          this.$t('matchMaking.primaryResult.5[3]'),
        ],
        6: [
          this.$t('matchMaking.primaryResult.6[0]'),
          this.$t('matchMaking.primaryResult.6[1]'),
          this.$t('matchMaking.primaryResult.6[2]'),
        ],
        7: [
          this.$t('matchMaking.primaryResult.7[0]'),
          this.$t('matchMaking.primaryResult.7[1]'),
        ],
        8: [
          this.$t('matchMaking.primaryResult.8[0]'),
          this.$t('matchMaking.primaryResult.8[1]'),
          this.$t('matchMaking.primaryResult.8[2]'),
        ],
        9: [
          this.$t('matchMaking.primaryResult.9[0]'),
          this.$t('matchMaking.primaryResult.9[1]'),
          this.$t('matchMaking.primaryResult.9[2]'),
        ],
        10: [
          this.$t('matchMaking.primaryResult.10[0]'),
          this.$t('matchMaking.primaryResult.10[1]'),
          this.$t('matchMaking.primaryResult.10[2]'),
        ],
        11: [
          this.$t('matchMaking.primaryResult.11[0]'),
          this.$t('matchMaking.primaryResult.11[1]'),
          this.$t('matchMaking.primaryResult.11[2]'),
        ],
        12: [
          this.$t('matchMaking.primaryResult.12[0]'),
          this.$t('matchMaking.primaryResult.12[1]'),
          this.$t('matchMaking.primaryResult.12[2]'),
          this.$t('matchMaking.primaryResult.12[3]'),
        ],
        13: [
          this.$t('matchMaking.primaryResult.13[0]'),
          this.$t('matchMaking.primaryResult.13[1]'),
          this.$t('matchMaking.primaryResult.13[2]'),
        ],
        14: [
          this.$t('matchMaking.primaryResult.14[0]'),
          this.$t('matchMaking.primaryResult.14[1]'),
          this.$t('matchMaking.primaryResult.14[2]'),
          this.$t('matchMaking.primaryResult.14[3]'),
        ]
      }
    }
  },
  computed: {

    firstQuestionMatchMaking() {
      return localStorage.getItem('firstQuestionMatchMaking')
    }
  },
  methods: {
    getPercentage(field) {
      switch (field) {
        case "1":
          return 83;
        case "2":
          return 82;
        case "3":
          return 79;
        case "4":
          return 89;
        case "5":
          return 85;
        case "6":
          return 90;
        case "7":
          return 91;
        case "8":
          return 89;
        case "9":
          return 73;
        case "10":
          return 86;
        case "11":
          return 90;
        case "12":
          return 81;
        case "13":
          return 73;
        case "14":
          return 75;
      }
      return Math.floor(Math.random() * (80 - 70 + 1) + 70);
    },
    changeStep() {
      this.$emit('changeStep')
    }
  }
}
</script>

<style scoped>
.onboardingType {
  line-height: 22pt;
}
</style>